'use client'

import dynamic from 'next/dynamic'

const DestinationPageDesktopContainer = dynamic(
    () => import(/* webpackChunkName: "DestinationPageDesktopContainer" */ '@/src/containers/desktop/destination'),
    { ssr: true }
)

const DestinationPageMobileContainer = dynamic(
    () => import(/* webpackChunkName: "DestinationPageMobileContainer" */ '@/src/containers/mobile/destination'),
    { ssr: true }
)

const DestinationRootLoader = ({ isMobile, domainCountry }: { isMobile: boolean; domainCountry: string }) => {
    return isMobile ? (
        <DestinationPageMobileContainer domainCountry={domainCountry} />
    ) : (
        <DestinationPageDesktopContainer domainCountry={domainCountry} />
    )
}

export default DestinationRootLoader
